export const SET_IMMUTABLE_INTERFACE_DATA = 'SET_IMMUTABLE_INTERFACE_DATA';
export const TOGGLE_TABLE_HEADER_FIXED = 'TOGGLE_TABLE_HEADER_FIXED';
export const SET_REGISTER_TABLE_WIDTHS = 'SET_REGISTER_TABLE_WIDTHS';
export const SET_FILTER_BAR_CONTAINER_WIDTH = 'SET_FILTER_BAR_CONTAINER_WIDTH';
export const SET_WIDTHS_FOR_WINDOW_RESIZE = 'SET_WIDTHS_FOR_WINDOW_RESIZE';

export function setImmutableInterfaceData(numTableColumns) {
    return {
        type: SET_IMMUTABLE_INTERFACE_DATA,
        numTableColumns,
    }
}

export function toggleTableHeaderIsFixed(tableHeaderIsFixed) {
    return {
        type: TOGGLE_TABLE_HEADER_FIXED,
        tableHeaderIsFixed
    }
}

export function setRegisterTableWidths(registerTableWidth, registerTableScrollWrapperWidth) {
    return {
        type: SET_REGISTER_TABLE_WIDTHS,
        registerTableWidth,
        registerTableScrollWrapperWidth
    }
}

export function setFilterBarContainerWidth(filterBarContainerWidth) {
    return {
        type: SET_FILTER_BAR_CONTAINER_WIDTH,
        filterBarContainerWidth
    }
}

export function setWidthsForWindowResize(registerTableScrollWrapperWidth, filterBarContainerWidth) {
    return {
        type: SET_WIDTHS_FOR_WINDOW_RESIZE,
        registerTableScrollWrapperWidth,
        filterBarContainerWidth
    }
}
